import Icon from '../components/Icon.vue'

Icon.register({
  star: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M259.3 17.8c11.8-23.9 45.7-23.6 57.4 0l65.3 132.4 146.1 21.3c26.2 3.8 36.7 36.1 17.7 54.6l-105.7 103 25 145.5c4.5 26.3-23.2 45.9-46.4 33.7l-130.7-68.7-130.7 68.7c-23.2 12.3-50.9-7.4-46.4-33.7l25-145.5-105.7-103c-19-18.5-8.5-50.8 17.7-54.6l146.1-21.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/star.js
// module id = 1949
// module chunks = 0